import React from 'react';
import Helmet from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';
import truncate from 'lodash/truncate';
import dayjs from 'dayjs';

export const Meta = ({ title, description, component, image, date }) => {
	const data = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title
					siteUrl
				}
			}
			sitePage {
				path
			}
		}
	`);
	const host = data.site.siteMetadata.siteUrl;
	const path = data.sitePage.path;
	const dateFormatted = date ? dayjs(date).format('YYYY-MM-DD') : null;

	// here we could maybe generate an image from a graph component
	// https://stackoverflow.com/a/55013028
	let img = image;

	const truncatedDescription = truncate(description, {
		length: 140,
		separator: /,? +/
	});
	return (
		<Helmet>
			{title && <meta name="title" content={title} />}
			{description && <meta name="description" content={truncatedDescription} />}
			// twitter
			<meta name="twitter:card" content="summary_large_image" />
			{title && <meta name="twitter:title" content={title} />}
			{description && <meta name="twitter:description" content={truncatedDescription} />}
			<meta name="twitter:image" content={img || `${host}/euromomo-cover.jpg`} />
			// OG
			<meta property="og:site_name" content="EUROMOMO" />
			{title && <meta property="og:title" content={title} />}
			{description && <meta property="og:description" content={truncatedDescription} />}
			{date && <meta property="og:type" content="article" />}
			{date && <meta property="article:published_time" content={dateFormatted} />}
			<meta property="og:locale" content="en_150" />
			<meta property="og:url" content={`${host}${path}`} />
			<meta property="og:image" content={img || `${host}/euromomo-cover.jpg`} />
		</Helmet>
	);
};

export default Meta;
